import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { applyHandoffFromHash } from "@itaas/core/modules/handoff";
import { getPort } from "@itaas/ports";
import { getSuiteLoginUrl } from "@/core/billing/config";
import { routes } from "@/router/all_routes";

export function AuthHandoffPage() {
  const navigate = useNavigate();
  const { verifySession } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const target = applyHandoffFromHash(window.location.hash) ?? null;

    if (target) {
      window.history.replaceState(null, "", window.location.pathname);
      void verifySession().then(() => {
        navigate(target || "/index", { replace: true });
      });
      return;
    }

    setError(
      `Lien de session invalide ou expiré. Connectez-vous via ITaaS Suite (port ${getPort("suite", "web")}).`,
    );
  }, [navigate, verifySession]);

  if (error) {
    return (
      <div className="billing-login-page">
        <div className="billing-login-card">
          <p className="text-danger mb-3">{error}</p>
          <a href={getSuiteLoginUrl()} className="btn btn-primary">
            Ouvrir ITaaS Suite
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="billing-login-page">
      <div className="billing-login-card">
        <p className="text-muted mb-0">Connexion au module Billing…</p>
      </div>
    </div>
  );
}
